import { MovieStatus, ScreenType, TvStatus } from '@tmdb-graphql-api/schema/types';
import { WatchlistCategory } from '#components/Watchlist/WatchlistCategory.ts';
import {
  DiscoverTypeLabel,
  DiscoverTypeRoute,
  ScreenFormatType,
  SectionType,
  type SectionTypeRoute,
} from '../enums/mediaTypes.ts';

export const mapDiscoverTypeRouteToScreenType = (type?: DiscoverTypeRoute) =>
  type === DiscoverTypeRoute.Tv ? ScreenType.Tv : ScreenType.Movie;

export const mapDiscoverTypeRouteToDiscoverTypeLabel = (type: DiscoverTypeRoute) =>
  type === DiscoverTypeRoute.Movies ? DiscoverTypeLabel.Movies : DiscoverTypeLabel.Tv;

export const mapScreenFormatTypeToScreenType = (type: ScreenFormatType) =>
  type === ScreenFormatType.Movie ? ScreenType.Movie : ScreenType.Tv;

export const mapScreenFormatTypeToSectionType = (type: ScreenFormatType) => {
  switch (type) {
    case ScreenFormatType.Movie: {
      return SectionType.Movie;
    }

    case ScreenFormatType.Tv: {
      return SectionType.Tv;
    }

    case ScreenFormatType.Season: {
      return SectionType.Season;
    }

    case ScreenFormatType.Episode: {
      return SectionType.Episode;
    }
  }
};

export const mapScreenTypeStatusToWatchlistCategory = (status: MovieStatus | TvStatus): WatchlistCategory => {
  switch (status) {
    case TvStatus.Canceled:

    // Same message for both for instances of ignore
    // eslint-disable-next-line no-fallthrough
    case MovieStatus.Canceled: {
      return WatchlistCategory.Canceled;
    }

    case MovieStatus.Rumored:

    // eslint-disable-next-line no-fallthrough
    case TvStatus.Planned:

    // eslint-disable-next-line no-fallthrough
    case MovieStatus.Planned: {
      return WatchlistCategory.Planned;
    }

    case TvStatus.InProduction:

    // eslint-disable-next-line no-fallthrough
    case MovieStatus.InProduction: {
      return WatchlistCategory.InProduction;
    }

    case TvStatus.Pilot:

    // eslint-disable-next-line no-fallthrough
    case TvStatus.ReturningSeries:

    // eslint-disable-next-line no-fallthrough
    case MovieStatus.PostProduction: {
      return WatchlistCategory.Upcoming;
    }

    case TvStatus.Ended:

    // eslint-disable-next-line no-fallthrough
    case MovieStatus.Released: {
      return WatchlistCategory.Completed;
    }
  }
};

export const mapScreenTypeToDiscoverTypeRoute = (type?: ScreenType) =>
  type === ScreenType.Tv ? DiscoverTypeRoute.Tv : DiscoverTypeRoute.Movies;

export const mapScreenTypeToScreenFormatType = (type: ScreenType) =>
  type === ScreenType.Movie ? ScreenFormatType.Movie : ScreenFormatType.Tv;

export const mapScreenTypeToSectionType = (type: ScreenType) =>
  type === ScreenType.Movie ? SectionType.Movie : SectionType.Tv;

// Most straight forward way to map right now
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const mapSectionTypeRouteToSectionType = (type: SectionTypeRoute) => type.toUpperCase() as SectionType;

export const mapSectionTypeToScreenType = (type: SectionType) =>
  type === SectionType.Movie ? ScreenType.Movie : ScreenType.Tv;

export const mapSectionTypeToScreenFormatType = (type: Exclude<SectionType, SectionType.Person>) => {
  switch (type) {
    case SectionType.Movie: {
      return ScreenFormatType.Movie;
    }

    case SectionType.Tv: {
      return ScreenFormatType.Tv;
    }

    case SectionType.Season: {
      return ScreenFormatType.Season;
    }

    case SectionType.Episode: {
      return ScreenFormatType.Episode;
    }
  }
};
